import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {datasetAttributePropType, MENUS} from '../../../../../utils/query_utils';
import {nextMenuEvent} from '../../../../../services/query_builder_events';
import {queryBuilderState} from '../../../../../services/query_builder_state';
import stopEvent from '../../../../../utils/stop_event';

export default class DatasetAttributeComponent extends Component {
    state = {
        focusNextInput: false,
    };
    columnInput = null;

    constructor(props) {
        super(props);
        this.onRemoveClick = this.onRemoveClick.bind(this);
    }


    componentDidMount() {
        this.unbindNextMenuListener = nextMenuEvent.listen(() => {
            if (this.props.attribute.id === queryBuilderState.attribute.id && queryBuilderState.menu !== MENUS.COLUMN) {
                this.setState({focusNextInput: true});
            }
        });
    }

    componentDidUpdate() {
        if (this.state.focusNextInput) {
            this.setState({focusNextInput: false});
        }
    }

    componentWillUnmount() {
        this.unbindNextMenuListener();
    }

    onRemoveClick(ev) {
        ev.preventDefault();
        this.props.onRemove();
    }

    canRemove() {
        return true;
    }

    renderAttribute() {
        return null;
    }

    renderPostAttribute() {
        return null;
    }

    focusInput() {
        this.columnInput.focusInput();
    }

    isLast() {
        const {position, totalAttributes} = this.props;
        return position === totalAttributes - 1;
    }

    render() {
        const {attribute} = this.props;
        return (
            <div className="input-tag-container" onClick={stopEvent}>
                <div style={{display: 'flex'}}>
                    {this.renderAttribute(attribute)}
                    {this.canRemove() && (
                        <button
                            className="delete-button input-tag-remove-btn"
                            onClick={this.onRemoveClick}
                            tabIndex="-1"
                        >
                            <img src="images/x.svg" alt="" width="8" height="8"/>
                        </button>
                    )}
                    {this.renderPostAttribute(attribute)}
                </div>
            </div>
        );
    }
}

DatasetAttributeComponent.propTypes = {
    attribute: datasetAttributePropType.isRequired,
    onRemove: PropTypes.func.isRequired,
    firstInList: PropTypes.bool,
    position: PropTypes.number,  // position of current attribute
    totalAttributes: PropTypes.number,  // total number of attributes
    datasetOpen: PropTypes.bool,  // is the dataset panel the main focus
};

DatasetAttributeComponent.defaultProps = {
    firstInList: false,
};
